var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapClasses},[_c('span',{class:_vm.prefix +'-dot'},[_c('i'),_vm._v(" "),_c('i'),_vm._v(" "),_c('i'),_vm._v(" "),_c('i')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTip),expression:"showTip"}],class:_vm.prefix + '-text'},[_vm._v(_vm._s(_vm.tip))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b55a266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./vb/components/spin/spinInner.vue
// module id = null
// module chunks = 